import {
  useMediaQuery,
  TableRow,
  TableCell,
  Table,
  TableBody,
  IconButton,
} from "@mui/material";
import React from "react";
import VisibilityIcon from "@mui/icons-material/Visibility";
import MUIDataTableWrapper from "components/MUIDataTableWrapper/MUIDataTableWrapper";

interface IAffiliateRecordAttendeeTableProps {
  title: string;
  records: any;
  onRowClick?: any;
}

const AffiliateRecordAttendeeTable: React.FC<IAffiliateRecordAttendeeTableProps> = (
  props
) => {
  const displayMobile = useMediaQuery("(max-width:959px)");

  const columns = [
    {
      label: "Attendee Id",
      name: "attendeeId",
      options: {
        display: "excluded",
      },
    },
    {
      label: "Member Id",
      name: "memberId",
    },
    {
      label: "Full Name",
      name: "fullname",
    },
    {
      label: "Credential Type",
      name: "credType",
      options: {
        display: displayMobile ? "false" : "true",
      },
    },
    {
      label: "Registered",
      name: "registered",
      options: {
        display: displayMobile ? "false" : "true",
      },
    }
  ];

  const viewButtonOnClick = (e: any, rowData: any) => {
    if (props.onRowClick) {
      props.onRowClick(rowData);
    }
  };

  return (
    <MUIDataTableWrapper
      title={props.title}
      onRowClick={props.onRowClick}
      options={{
        print: false,
        download: false,
        viewColumns: false,
        filter: false,
        rowsPerPageOptions: [5, 10, 15, 25],
        selectableRows: "none",
      }}
      data={props.records.map((record: any) => {
        return {
          attendeeId: record.attendeeId,
          memberId: record.memberId ? record.memberId : "N/A",
          fullname: record.firstName + " " + record.lastName,
          credType: record.credentialType ?? "N/A",
          registered: record.registered ? "Yes" : "No",
          hotel: record.hotelReservation ? "Yes" : "No",
          checkedIn: record.checkedIn ? "Yes" : "No",
        };
      })}
      columns={columns}
      setExpandableRowContent={(rowData: any) => {
        console.log(rowData);
        return (
          <TableRow>
            <TableCell />
            <TableCell colSpan={3}>
              <Table>
                <TableBody className="inner-tbody-expandable-row">
                  <TableRow>
                    <TableCell className="tbl-col-container">
                      <div className="tbl-col-title">View</div>
                      <div>
                        <IconButton
                          aria-label="edit-user"
                          size="small"
                          onClick={(e) => viewButtonOnClick(e, rowData)}
                          className="edit-button-expandable-rows"
                        >
                          <VisibilityIcon />
                        </IconButton>
                      </div>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell align="left" className="tbl-col-container">
                      <div className="tbl-col-title">Registered</div>
                      <div>{rowData[3] ? rowData[3].toString() : "N/A"}</div>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell align="left" className="tbl-col-container">
                      <div className="tbl-col-title">Hotel</div>
                      <div>{rowData[4] ? rowData[4].toString() : "N/A"}</div>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell align="left" className="tbl-col-container">
                      <div className="tbl-col-title">Checked-In</div>
                      <div>{rowData[5] ? rowData[5].toString() : "N/A"}</div>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableCell>
          </TableRow>
        );
      }}
    />
  );
};

export default AffiliateRecordAttendeeTable;
